import { render, staticRenderFns } from "./EventBreak.vue?vue&type=template&id=399d4a5a&"
import script from "./EventBreak.vue?vue&type=script&lang=js&"
export * from "./EventBreak.vue?vue&type=script&lang=js&"
import style0 from "./EventBreak.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports